import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08527fa1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }

import { computed } from 'vue'

interface IProps {
  /**
   * 设备状态
   * -1:离线 mqtt离线&前1分钟无事件2，3，4
   *  1:在线 mqtt在线
   *  2:连接中 xos开始启动
   *  3:重启中 客户端下发reboot指令
   *  4:升级中 客户端下发升级指令
   *  5:下载中
   *  6:安装中
   */
  status: number
}
const enum EStatus {
  Offline = -1,
  Online = 1,
  Connecting = 2,
  Rebooting = 3,
  Upgrading = 4,
  Downloading = 5,
  Installing = 6,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as {
  /**
   * 设备状态
   * -1:离线 mqtt离线&前1分钟无事件2，3，4
   *  1:在线 mqtt在线
   *  2:连接中 xos开始启动
   *  3:重启中 客户端下发reboot指令
   *  4:升级中 客户端下发升级指令
   *  5:下载中
   *  6:安装中
   */
  status: number
}



const state = computed(() => {
  if (props.status === EStatus.Online) return 'online'
  if ([EStatus.Connecting, EStatus.Rebooting, EStatus.Upgrading].includes(props.status)) return 'connecting'
  return 'offline'
})

const label = computed(() => {
  if (props.status === EStatus.Online) return '在线'
  if (props.status === EStatus.Connecting) return '连接中...'
  if (props.status === EStatus.Rebooting) return '重启中...'
  if (props.status === EStatus.Upgrading) return '升级中...'
  return '离线'
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["device-state", _unref(state)])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(label)), 1)
  ], 2))
}
}

})